var $916521e9800ac46c$exports = {};
$916521e9800ac46c$exports = {
    "(optional)": `(valfritt)`,
    "(required)": `(kr\xe4vs)`
};


export {$916521e9800ac46c$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
